import { AppNS } from 'app';
import { assetUrl } from 'app/helpers/assetUrl';
import { can } from 'app/helpers/can';
import { isLoggedInAsAdmin } from 'app/helpers/isLoggedInAsAdmin';
import { Params } from 'app/types';
import BookingsIcon from 'app/ui/icons/BookingsIcon';
import DashboardIcon from 'app/ui/icons/DashboardIcon';
import FileTypePdfIcon from 'app/ui/icons/FileTypePdfIcon';
import MessagingIcon from 'app/ui/icons/MessagingIcon';
import PaymentsIcon from 'app/ui/icons/PaymentsIcon';
import ProfileIcon from 'app/ui/icons/ProfileIcon';
import ReviewsIcon from 'app/ui/icons/ReviewsIcon';
import SettingsIcon from 'app/ui/icons/SettingsIcon';
import AgencyInspectorsIcon from 'app/ui_v2/icons/AgencyInspectorsIcon';
import AgencyProfileIcon from 'app/ui_v2/icons/AgencyProfileIcon';
import CertificatesMenuIcon from 'app/ui_v2/icons/CertificatesMenuIcon';
import InspectionsMenuIcon from 'app/ui_v2/icons/InspectionsMenuIcon';
import InspectorIcon from 'app/ui_v2/icons/InspectorIcon';
import TicketsIcon from 'app/ui_v2/icons/TicketsIcon';
import WindowBookmarkIcon from 'app/ui_v2/icons/WindowBookmarkIcon';

import { isUserHasInspectorProfile, isUserHasProfile } from '../config';

const agencyGuideUrl = assetUrl('../../../Tertius_User_Guide_for_Third-Party_Agencies_12.22.22.pdf');

export const getAgencyNavigation = (user: AppNS.User): AppNS.NavigationElement[] => [
  {
    id: 'dashboard',
    name: 'Dashboard',
    url: '/agency/dashboard',
    path: '/agency/dashboard',
    icon: <DashboardIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'bookings',
    name: 'Projects',
    url: '/agency/bookings',
    path: ['/agency/bookings', '/agency/bookings/:section'],
    icon: <BookingsIcon />,
    disabled: false,
    // !ifAgencyCompletedFirstMilestone(user) &&
    // !ifAgencyDuringOnboarding(user),
    show: isUserHasProfile(user),
    main: true,
  },
  {
    id: 'inspections',
    name: 'Inspections',
    url: '/agency/inspections/upcoming',
    path: '/agency/inspections/:section',
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: isUserHasProfile(user),
    main: true,
  },
  {
    id: 'messaging',
    name: 'Messaging',
    url: '/agency/messaging',
    path: '/agency/messaging/inbox',
    icon: <MessagingIcon />,
    disabled: false,
    show: can(user, 'manage_projects'),
  },
  {
    id: 'payments',
    name: 'Payments',
    url: '/agency/payments/payments-list',
    path: '/agency/payments/:section',
    icon: <PaymentsIcon />,
    disabled: false,
    show: can(user, 'view_company_payments'),
  },
  {
    id: 'reviews',
    name: 'Reviews',
    url: '/agency/reviews',
    path: '/agency/reviews',
    icon: <ReviewsIcon />,
    disabled: false,
    show: can(user, 'manage_company_profile'),
  },
  {
    id: 'inspectors',
    name: 'TP Inspectors',
    url: '/agency/inspector',
    path: ['/agency/inspector', `/agency/inspector/:id/:section`],
    pathExceptions: `/agency/inspector/${user.inspectorProfile?.id}/:section`,
    icon: <AgencyInspectorsIcon />,
    disabled: false,
    show: false, //isUserHasProfile(user),
    settings: false,
  },
  {
    id: 'inspector_profile',
    name: 'My Inspector Profile',
    url: '/agency/my-inspector',
    path: [
      `/agency/inspector/${user.inspectorProfile?.id}/:section`,
      `/agency/inspector/${user.inspectorProfile?.id}/:section/:section-1`,
    ],
    icon: <InspectorIcon />,
    disabled: false,
    show: isUserHasInspectorProfile(user),
    settings: false,
  },
  {
    id: 'agency_profile',
    name: 'My Agency Profiles',
    url: '/agency/profile',
    path: ['/agency/:id/:section', 'agency/profile', 'agency/:id/:section/:section-1'],
    pathExceptions: [
      `/agency/inspector/${user.inspectorProfile?.id}/:section`,
      '/agency/tickets/:id/:section',
      '/agency/payments/:section',
      '/agency/inspections/:section',
      '/agency/bookings/:section',
      '/agency/reviews/:section',
      '/agency/messaging/:section',
    ],
    icon: <AgencyProfileIcon />,
    disabled: false,
    show: can(user, 'manage_company_profile') || user.employments.length > 0,
    settings: false,
  },
  {
    id: 'tickets',
    name: 'TP Verification',
    url: '/agency/tickets',
    path: ['/agency/tickets', '/agency/tickets/:id/:section'],
    icon: <TicketsIcon />,
    disabled: false,
    // show: can(user, 'manage_company_profile'),
    show: can(user, 'manage_company_profile') || Boolean(user.inspectorProfile?.id),
    settings: false,
  },
  {
    id: 'guide',
    name: `User Guide`,
    url: agencyGuideUrl,
    path: agencyGuideUrl,
    icon: <FileTypePdfIcon />,
    disabled: false,
    show: true,
    isExternal: true,
  },
  {
    id: 'settings',
    name: 'Manage My Accounts',
    url: '/agency/account',
    path: '/agency/account',
    icon: <SettingsIcon />,
    disabled: false,
    show: true,
    settings: true,
  },
];

export const getElevatorsAgencyNavigation = (user: AppNS.User): AppNS.NavigationElement[] => [
  {
    id: 'elevatorsProjects',
    name: 'Projects',
    url: '/agency/elevators/projects',
    path: '/agency/elevators/projects',
    icon: <WindowBookmarkIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsCertificates',
    name: 'Certificates',
    url: '/agency/elevators/certificates',
    path: '/agency/elevators/certificates',
    icon: <CertificatesMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'elevatorsInspections',
    name: 'Inspections',
    url: '/agency/elevators/inspections',
    path: '/agency/elevators/inspections',
    icon: <InspectionsMenuIcon />,
    disabled: false,
    show: true,
    main: true,
  },
  {
    id: 'messaging',
    name: 'Messaging',
    url: '/client/messaging/inbox',
    path: '/client/messaging',
    icon: <MessagingIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'account',
    name: 'Profile',
    url: '/agency/account',
    path: '/agency/account',
    icon: <ProfileIcon />,
    disabled: false,
    show: true,
  },
  {
    id: 'agency_profile',
    name: 'Agency & Users',
    url: '/agency/profile',
    path: '/agency/:id',
    icon: <AgencyProfileIcon />,
    disabled: false,
    show: can(user, 'manage_company_profile'),
    settings: true,
  },
  {
    id: 'settings',
    name: 'Settings',
    url: '/agency/settings',
    path: '/agency/settings',
    icon: <SettingsIcon />,
    disabled: false,
    show: true,
    settings: true,
  },
];

export const getAgencyApps = (): Params[] => [
  {
    id: 'third-party',
    name: '3rd Party Inspections',
    homeUrl: '/agency/dashboard',
  },
  (isLoggedInAsAdmin() && {
    id: 'admin-panel',
    name: 'Back To Admin Panel',
    homeUrl: getAdminLink(),
    isExternal: true,
  }) ||
    {},

  // {
  //   id: 'elevators',
  //   name: 'Elevators',
  //   homeUrl: '/elevators',
  // },
];

export const getBackOfficeApps = (): Params[] => [
  {
    id: 'dcra-inspections',
    name: 'DOB Inspections',
    homeUrl: '/dcra-inspections/inspections/scheduled',
  },
  {
    id: 'admin-panel',
    name: 'Back To Admin Panel',
    homeUrl: getAdminLink(),
    isExternal: true,
  },
  // {
  //   id: 'elevators',
  //   name: 'Elevators',
  //   homeUrl: '/elevators',
  // },
];

export const getAdminLink = (): string => {
  // if localhost
  if (window.location.hostname === 'localhost') {
    return 'http://localhost:3001/admin';
  }
  return '/../admin';
};
